import styles from './ReportButton.module.scss';
import React, { FunctionComponent, ReactElement, useState } from 'react';


export interface IReportButtonProps {
  buttonText: string;
  handleClick: (e: any) => void;
}

const GenericButton: FunctionComponent<IReportButtonProps> = (props, { buttonText, handleClick, children }) => {
  const [hover, setHover] = useState(false);
  const elements = React.Children.toArray(props.children)

  return (
    <>
      <button
        className={styles.genericButton}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={(e) => props.handleClick(e)}
      >
        {/* <span className={`${styles.icon} ${styles.baseline}`}>{React.cloneElement(elements[0] as ReactElement, {hovered: hover})}</span> */}
        <span className={styles.buttonText}>{props.buttonText}</span>
      </button>
    </>
  );
};

export default GenericButton;
